import http from '../../../Utils/http';
import responseMessageHandler from '../../../Utils/ResponseMessageHandler';

const getCampaignBudgetCost = {
  name: 'getCampaignBudgetCost',
  state: {
    loading: false,
    error: '',
    budget: 0,
    cost: 0,
  },
  reducers: {
    getRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
        budget: 0,
        cost: 0,
      };
    },

    getReceived(state, payload) {
      return {
        ...state,
        loading: false,
        error: '',
        budget: payload.budget,
        cost: payload.cost,
      };
    },

    getRequestFailed(state, payload) {
      return {
        ...state,
        loading: false,
        error: payload,
      };
    },
  },
  effects: (dispatch) => ({
    async getBudgetCost() {
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        const orgId = userInfo?.org_id;
        const url = `savvy/organization/campaign-budget-cost/${orgId}`;
        this.getRequested();
        const response = await http.get(url);
        if (response && response?.data) {
          this.getReceived({
            budget: (response.data.data.budget).toFixed(2),
            cost: (response.data.data.cost).toFixed(2),
          });
        }
      } catch (err) {
        this.getRequestFailed(err.message);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: responseMessageHandler.show(err.message),
            show: true,
          },
        });
      }
    },
  }),
};

export default getCampaignBudgetCost;
